import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { CropperModal } from "@wrstudios/components";
import AlertDanger from "../common/AlertDanger";
import IconPhoto from "../../components/icons/IconPhoto";
import Button from "./Button";
import {
  Photo,
  PhotoFile,
  PhotoFileInner,
  PhotoFileInput,
  PhotoFilePicker,
  PhotoFilePickerIcon,
  PhotoFilePickerText,
  PhotoFilePreview,
  PhotoFilePreviewImage,
  PhotoFileControls,
  PhotoFileControlsChange,
  PhotoFileControlsDelete
} from "./styled/photo-selector";
import { IconTrashCan } from "@wrstudios/icons";

function PhotoSelector({ id, footer, onChange, onCrop, onDelete, ...props }) {
  const photoRef = useRef();
  const [showCropper, setShowCropper] = useState(false);
  const [hasPhotoBeenSelected, setHasPhotoBeenSelected] = useState(
    !!props.previewUrl
  );
  const [previewUrl, setPreviewUrl] = useState(props.previewUrl || "");
  const [files, setFiles] = useState();
  const [showAlert, setShowAlert] = useState(false);

  const handleChange = (e) => {
    const hasFiles = !!e.target.files.length;
    const [firstPhoto] = e.target.files;

    if (!hasFiles) {
      setHasPhotoBeenSelected(false);
      setPreviewUrl("");
    }

    if (firstPhoto) {
      const reader = new FileReader();
      reader.onload = (ee) => {
        setPreviewUrl(ee.target.result);
        setShowCropper(hasFiles);
        onChange(e);
      };
      reader.readAsDataURL(firstPhoto);
    }
    setFiles(e.target.files);
  };

  const handleCrop = (data) => {
    setPreviewUrl(data.getDataURL());
    setHasPhotoBeenSelected(true);
    setShowCropper(false);
    onCrop({ data: data.getData(), files });
  };

  const handleDelete = () => {
    setHasPhotoBeenSelected(false);
    setPreviewUrl("");

    setShowAlert(false);
    onDelete();
  };

  return (
    <>
      <Photo>
        <PhotoFileInput
          ref={photoRef}
          type="file"
          id={id}
          onChange={handleChange}
        />
        {showCropper && (
          <CropperModal
            imageUrl={previewUrl}
            onClose={() => setShowCropper(false)}
            footer={(data) =>
              typeof footer === "function" ? (
                footer({ ...data, handleCrop: () => handleCrop(data) })
              ) : (
                <Button
                  app="cma"
                  type="button"
                  onClick={() => handleCrop(data)}>
                  Submit
                </Button>
              )
            }
          />
        )}
        <PhotoFile>
          <PhotoFileInner>
            {!hasPhotoBeenSelected && (
              <PhotoFilePicker htmlFor="photo">
                <PhotoFilePickerIcon>
                  <IconPhoto />
                </PhotoFilePickerIcon>
                <PhotoFilePickerText>Upload Photo</PhotoFilePickerText>
              </PhotoFilePicker>
            )}
            {hasPhotoBeenSelected && (
              <PhotoFilePreview>
                <PhotoFilePreviewImage src={previewUrl} />
                <PhotoFileControls>
                  <PhotoFileControlsChange
                    type="button"
                    onClick={() => photoRef.current.click()}>
                    Change
                  </PhotoFileControlsChange>
                  <PhotoFileControlsDelete
                    type="button"
                    onClick={() => setShowAlert(true)}>
                    <IconTrashCan />
                    Delete
                  </PhotoFileControlsDelete>
                </PhotoFileControls>
              </PhotoFilePreview>
            )}
          </PhotoFileInner>
        </PhotoFile>
      </Photo>
      {showAlert && (
        <AlertDanger
          title="Delete Photo"
          confirmButton="Delete Forever"
          onConfirm={handleDelete}
          onClose={() => setShowAlert(false)}>
          Are you sure you want to remove the photo?
        </AlertDanger>
      )}
    </>
  );
}

PhotoSelector.defaultProps = {
  onChange: () => {},
  onDelete: () => {}
};

PhotoSelector.propTypes = {
  previewUrl: PropTypes.string,
  cropData: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
    x: PropTypes.number,
    y: PropTypes.number
  }),
  footer: PropTypes.func,
  onDelete: PropTypes.func
};

export default PhotoSelector;
